import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Flame, Heart, Eye, BadgeCheck, ArrowLeft } from "lucide-react";
import Banners from "../components/Banners";
import { TrendingSidebar } from "../components/TrendingSidebar";

export default function Trending() {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/reels/trending?hours=24").then(r => { setReels(r.data); setLoading(false); }).catch(()=>setLoading(false));
  }, []);

  return (
    <div className="py-6 pb-24">
      <div className="px-4 flex items-center gap-2 mb-1">
        <Flame className="w-7 h-7 text-[#FF2A5F]"/>
        <h1 className="font-outfit font-extrabold text-3xl tracking-tighter">Discover</h1>
      </div>
      <p className="px-4 text-white/60 text-sm mb-3">Top creators · Live now · Top gifters · Trending topics</p>

      <Banners />

      {/* Mobile-visible widgets (Top Creators + Live Now, Top Gifters + Trending) */}
      <div className="px-4 mt-4 space-y-3 xl:hidden" data-testid="mobile-trending-widgets">
        <TrendingSidebar side="left" variant="inline"/>
        <TrendingSidebar side="right" variant="inline"/>
      </div>

      <div className="px-4 mt-4">{loading ? <div className="text-center text-white/50 py-8">Loading...</div> : (
        <div className="grid grid-cols-2 gap-3" data-testid="trending-list">
          {reels.map((r, idx) => (
            <Link key={r.id} to={`/`} data-testid={`trending-${r.id}`}
              className="relative aspect-[9/16] rounded-2xl overflow-hidden border border-white/10 active:scale-95 transition group">
              <video src={r.video_url} muted loop autoPlay playsInline className="absolute inset-0 w-full h-full object-cover"/>
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/85"/>
              <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-[#FF2A5F] text-[10px] font-extrabold flex items-center gap-1">
                <Flame className="w-3 h-3"/>#{idx+1}
              </div>
              <div className="absolute bottom-0 inset-x-0 p-2.5">
                <div className="flex items-center gap-1.5 mb-1">
                  <img src={r.user?.avatar} className="w-5 h-5 rounded-full"/>
                  <span className="text-[10px] font-bold truncate">@{r.user?.username}</span>
                  {r.user?.verified && <BadgeCheck className="w-3 h-3 text-[#00E5FF]"/>}
                </div>
                <p className="text-xs leading-tight line-clamp-2">{r.title}</p>
                <div className="flex items-center gap-2 mt-1 text-[10px] text-white/80">
                  <Heart className="w-3 h-3 fill-[#FF2A5F] text-[#FF2A5F]"/>{r.likes}
                  <Eye className="w-3 h-3 ml-1"/>{r.views}
                </div>
              </div>
            </Link>
          ))}
          {reels.length === 0 && <p className="col-span-2 text-center text-white/40 py-8">No trending reels yet</p>}
        </div>
      )}
      </div>
    </div>
  );
}
